export default __webpack_public_path__ + "static/media/gray.3aee9046.svg";